import MenuList from "./MenuList";

export default MenuList;
